import { healthConditionMap } from '../../common/const'

// date format will be in dayjs
export const getDateStr = (date = {}) => {
  return `${date['$y']}-${date['$M'] + 1}-${date['$D']}`
}

export const parseQueryString = (queryString) => {
  var params = {}
  var queryStringWithoutQuestionMark = queryString.substring(1) // Remove the leading '?'
  var keyValuePairs = queryStringWithoutQuestionMark.split('&')

  for (var i = 0; i < keyValuePairs.length; i++) {
    var keyValuePair = keyValuePairs[i].split('=')
    var key = decodeURIComponent(keyValuePair[0])
    var value =
      keyValuePair.length > 1 ? decodeURIComponent(keyValuePair[1]) : null

    params[key] = value
  }

  return params
}

export const getUrlParams = () => {
  if (typeof window !== 'undefined') {
    return parseQueryString(window.location.search)
  } else {
    return {}
  }
}

export const formatCurrency = (input) => {
  const number = typeof input === 'string' ? parseFloat(input) : input
  return isNaN(number)
    ? null
    : new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(number)
}

export const conditionNameToDiseaseMapping = (condition_name) => {
  switch (condition_name) {
    case 'diabetes':
      return 'Diabetes'
    case 'pcos':
      return 'PCOS'
    case 'fatty-liver':
      return 'Fatty Liver - NAFL'
    case 'obesity':
      return 'Others'
    default:
      return 'Others'
  }
}

export const therapyAreaMapping = (therapyArea) => {
  switch (therapyArea) {
    case 'metabolism':
      return 'Metabolism'
    default:
      return ''
  }
}

export const base64ToFile = (base64, fileName, mimeType) => {
  const byteString = atob(base64.split(',')[1]) // Decode Base64
  const byteArray = new Uint8Array(byteString.length).map((_, i) =>
    byteString.charCodeAt(i),
  ) // Convert to byte array
  return new File([byteArray], fileName, { type: mimeType })
}

export const createPNDSPayload = (questions, capturedImage) => {
  const PNDS_formData = new FormData()

  const age = questions.find((q) => q.id === 'age')?.answer?.value
  const heightInM = questions.find((q) => q.id === 'height')?.answer?.value
  const weightInKg = questions.find((q) => q.id === 'weight')?.answer?.value
  const daily_activity = questions.find((q) => q.id === 'daily_activity')
    ?.answer?.value
  const gender = questions.find((q) => q.id === 'gender')?.answer?.value

  const bmi = weightInKg / (heightInM * heightInM)

  const healthCondition =
    questions.find((q) => q.id === 'comorbid_condition')?.answer?.value || 'CKD'

  const health_condition =
    healthConditionMap[healthCondition] || 'chronic kidney disease'

  PNDS_formData.append('age', age.toString())
  PNDS_formData.append('bmi', parseFloat(bmi).toFixed(2))
  PNDS_formData.append('daily_activity', daily_activity.toString())
  PNDS_formData.append(
    'gender',
    (gender === 'Male' ? 'male' : 'female').toString(),
  )
  PNDS_formData.append('health_condition', health_condition)
  PNDS_formData.append(
    'file',
    base64ToFile(capturedImage, 'food-scan.png', 'image/png'),
  )

  return PNDS_formData
}

export const sendMessageToParent = (eventName, data = {}) => {
  try {
    console.log('Sending message: ', eventName, ' with data: ', data)
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: eventName, data }),
    )
  } catch (error) {
    console.log('sendMessageToParent ERROR', error)
  }
}
